import type { Location, NavigateFunction } from 'react-router-dom';

import type { AxiosError } from 'axios';

import { Permissions } from '@shared/config/permissionsEnums';
import { RoutePaths } from '@shared/config/routePathsEnum';
import { SelectedBranchState } from '@shared/model/app_store/AppStore';
import type { IAccount, ID, IError } from '@shared/types/BaseQueryTypes';
import { publishAuthSessionFromBearer } from '@shared/lib/authSessionSync';

type OnFetchDataHandlingArgs = {
  error: AxiosError<IError>;
  user: IAccount;
  navigate: NavigateFunction;
  location: Location;
  auth: boolean;
  route: Partial<keyof typeof RoutePaths> | string;
  setState: (data: {
    selectedBranchState?: SelectedBranchState;
    auth?: boolean;
    assignmentBranch?: SelectedBranchState;
    isAdmin?: boolean;
    email?: string;
    permissions?: string[];
    id?: ID;
    fullName?: string;
  }) => void;
};

export const onFetchDataHandling = ({
  error,
  user,
  navigate,
  location,
  auth,
  route,
  setState,
}: OnFetchDataHandlingArgs) => {
  const isAdmin = (user?.permissions || []).includes(Permissions.SYSTEM_GLOBAL_ADMIN);
  if (user) {
    setState({
      auth: true,
      email: user?.email,
      assignmentBranch: user?.assignment?.branch,
      permissions: user?.permissions,
      isAdmin: isAdmin,
      id: user?.id,
      fullName: user?.fullName,
    });

    if (user.fullName) {
      localStorage.setItem('userFullName', user.fullName);
    }
    publishAuthSessionFromBearer();
  }
  if (location?.pathname === '/' && !error && user) {
    navigate(route, { replace: true });
  } else if (error || (!auth && !user)) {
    navigate(RoutePaths.auth);
  }
};
